import template from './carrier.html';
import controller from './carrier.controller';
import './carrier.scss';

let carrierComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default carrierComponent;


// WEBPACK FOOTER //
// ./client/app/components/carrier/carrier.component.js